<template>
    <div>
        <div v-if="!user">Loading...</div>
        <div v-else>
            <div class="content">
                <div class="row">
                    <div class="col-md-8 col-xl-8">
                        <a
                            class="block block-link-shadow"
                            href="javascript:void(0)"
                        >
                            <div
                                class="block-content block-content-full clearfix"
                            >
                                <div class="float-left">
                                    <img
                                        class="img-avatar img-avatar128"
                                        :src="
                                            user.avatar
                                                ? `/avatar/${user.avatar}`
                                                : '/media/avatars/avatar9.jpg'
                                        "
                                    />
                                    <div class="mt-5 text-center">
                                        <button
                                            type="button"
                                            @click.prevent="showIDCard"
                                        >
                                            View ID Card
                                        </button>
                                    </div>
                                </div>
                                <div class="text-right float-right mt-10">
                                    <div class="font-w600 mb-5 text-danger">
                                        <a
                                            v-if="user.isActive == 0"
                                            class="badge badge-danger"
                                            href="javascript:void(0)"
                                            >Account Inactive</a
                                        >
                                        <a
                                            v-else
                                            class="badge badge-success"
                                            href="javascript:void(0)"
                                            >Account Active</a
                                        >
                                    </div>
                                    <div class="font-w600 mb-5 text-danger">
                                        <a
                                            v-if="user.txn_ban == 0"
                                            class="badge badge-success"
                                            href="javascript:void(0)"
                                            >Transaction Enabled</a
                                        >
                                        <a
                                            v-else
                                            class="badge badge-danger"
                                            href="javascript:void(0)"
                                            >Transaction Disabled</a
                                        >
                                    </div>
                                    <div class="font-w600 mb-5 text-danger">
                                        <a
                                            v-if="user.ban == 0"
                                            class="badge badge-success"
                                            href="javascript:void(0)"
                                            >Not Banned</a
                                        >
                                        <a
                                            v-else
                                            class="badge badge-danger"
                                            href="javascript:void(0)"
                                            >Banned</a
                                        >
                                    </div>
                                    <div class="font-size-sm text-muted">
                                        Joined:
                                        {{
                                            new Date(
                                                user.created_at
                                            ).toDateString()
                                        }}
                                    </div>
                                    <div class="row mt-10">
                                        <button
                                            :disabled="processing"
                                            class="btn btn-sm mr-2"
                                            @click.prevent="updateAccountStatus"
                                        >
                                            <span v-if="user.isActive == 1"
                                                >Deactivate Account</span
                                            >
                                            <span v-else>Activate Account</span>
                                        </button>
                                        <button
                                            :disabled="processing"
                                            class="btn btn-sm mr-2"
                                            @click.prevent="
                                                updateTransactionStatus
                                            "
                                        >
                                            <span v-if="user.txn_ban == 1"
                                                >Enable Transaction</span
                                            >
                                            <span v-else
                                                >Disable Transaction</span
                                            >
                                        </button>
                                        <button
                                            :disabled="processing"
                                            class="btn btn-sm"
                                            @click.prevent="updateBanStatus"
                                        >
                                            <span v-if="user.ban == 0"
                                                >Ban Account</span
                                            >
                                            <span v-else>Cancel Ban</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-4"></div>
                </div>

                <div class="mt-3">
                    <div>
                        <!-- tab content navigation -->
                        <div class="row align-items-center">
                            <div class="col">
                                <ul
                                    class="nav nav-tabs nav-tabs-alt js-tabs-enabled"
                                    role="tablist"
                                >
                                    <li class="nav-item">
                                        <a
                                            class="nav-link active"
                                            id="personal-tab"
                                            data-toggle="tab"
                                            href="#personal"
                                            role="tab"
                                            aria-controls="personal"
                                            aria-selected="true"
                                            >Personal Info</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            id="account-tab"
                                            data-toggle="tab"
                                            href="#account"
                                            role="tab"
                                            aria-controls="account"
                                            aria-selected="false"
                                            >Account Info</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            id="transactions-tab"
                                            data-toggle="tab"
                                            href="#transactions"
                                            role="tab"
                                            aria-controls="transactions"
                                            aria-selected="false"
                                            >Transactions</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- end of tab content navigation -->
                        <!-- tab content  -->
                        <div class="tab-content" id="myTabContent">
                            <div
                                class="tab-pane fade show active"
                                id="personal"
                                role="tabpanel"
                                aria-labelledby="personal-tab"
                            >
                                <personal-component
                                    :user="user"
                                    @refresh="fetchUser"
                                />
                            </div>
                            <div
                                class="tab-pane fade"
                                id="account"
                                role="tabpanel"
                                aria-labelledby="account-tab"
                            >
                                <div class="row py-10">
                                    <div class="col-6">
                                        <button
                                            class="btn btn-sm btn-danger"
                                            @click.prevent="updateBalancesModal"
                                        >
                                            Update Balance
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div
                                        class="col-12 col-xl-3"
                                        v-for="account in user.accounts"
                                        :key="account.id"
                                    >
                                        <a v-if="account.isActive == 1"
                                            class="block block-link-shadow text-right"
                                            href="javascript:void(0)"
                                        >
                                            <div
                                                class="block-content block-content-full clearfix"
                                            >
                                                <div
                                                    class="float-left mt-10 d-none d-sm-block"
                                                ></div>
                                                <div
                                                    class="font-size-h3 font-w600"
                                                >
                                                    {{ account.currency.symbol
                                                    }}<span
                                                     
                                                        >{{
                                                            parseFloat(
                                                                account.balance
                                                            )
                                                                .toFixed(2)
                                                                .replace(
                                                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                                                    "$1,"
                                                                )
                                                        }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="font-size-sm font-w600 text-uppercase text-muted"
                                                >
                                                    {{ account.number }} ({{
                                                        account.currency.code
                                                    }}
                                                    )
                                                </div>
                                                <div
                                                    class="font-size-sm font-w600 text-uppercase text-muted"
                                                >
                                                    {{ account.type }}
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="transactions"
                                role="tabpanel"
                                aria-labelledby="transactions-tab"
                            >
                                <div class="py-10">
                                    <transactions-component
                                        :user="user"
                                        @refresh="fetchUser"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- balances modal  -->
            <div
                class="modal fade"
                id="modal-balances"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-fadein"
                style="display: none;"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="card-title">Update Balance</h3>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- Beginning of the form -->
                        <form @submit.prevent="updateBalance">
                            <div class="modal-body">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="form-group">
                                            <label for="name"
                                                >Select type</label
                                            >
                                            <select
                                                type="text"
                                                class="form-control"
                                                v-model="type"
                                                required
                                            >
                                                <option value selected disabled
                                                    >Select Transaction
                                                    Type</option
                                                >
                                                <option value="1"
                                                    >Credit Account</option
                                                >
                                                <option value="0"
                                                    >Debit Account</option
                                                >
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="name"
                                                >Select Account</label
                                            >
                                            <select
                                                type="text"
                                                class="form-control"
                                                v-model="account"
                                                required
                                            >
                                                <option value selected disabled
                                                    >--- Select Account
                                                    ---</option
                                                >
                                                <option
                                                    v-for="account in user.accounts"
                                                    :key="account.id" v-if="account.isActive == 1" :value="account.id"
                                                    > {{ account.currency.symbol }}{{  parseFloat(
                                                                account.balance
                                                            )
                                                                .toFixed(2)
                                                                .replace(
                                                                    /(\d)(?=(\d{3})+(?!\d))/g,
                                                                    "$1,"
                                                                ) }} - {{ account.number }} </option
                                                >
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="name">Amount</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="amount"
                                                required
                                            />
                                        </div>

                                        <div class="form-group row">
                                            <div
                                                v-if="processing"
                                                class="col-6 col-md-3"
                                            >
                                                <i
                                                    class="fa fa-2x fa-cog fa-spin text-primary"
                                                ></i>
                                            </div>
                                            <div class="col-md-9" v-else>
                                                <button
                                                    type="submit"
                                                    class="btn btn-lg btn-outline-info mb-2"
                                                >
                                                    Update Balance
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- balances modal ends  -->
        </div>
    </div>
</template>
<script>
import PersonalComponent from "../../../components/Personal";
import TransactionsComponent from "../../../components/Transactions";
import { RepositoryFactory } from "../../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");

export default {
    components: {
        PersonalComponent,
        TransactionsComponent
    },
    data() {
        return {
            user: undefined,
            processing: false,
            image_url: "",
            avatar: "",
            file: "",
            amount: 0,
            currency: 2,
            type: 1,
            account: "balance"
        };
    },
    methods: {
        async updateBalance() {
            try {
                this.processing = true;
                var data = {
                    type: this.type,
                    amount: this.amount,
                    account: this.account
                };
                await UsersRepository.updateBalance(this.user.id, data);
                this.processing = false;
                await this.fetchUser();
                toast.fire({
                    type: "success",
                    title: `Account updated successfully`
                });
                $("#modal-balances").modal("hide");
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
                this.processing = false;
            }
        },
        updateBalancesModal() {
            $("#modal-balances").modal("show");
        },
        async updateAccountStatus() {
            try {
                this.processing = true;
                await UsersRepository.updateAccountStatus(this.user.id);
                await this.fetchUser();
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Account status updated"
                });
            } catch (error) {
                this.processing = false;
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async updateTransactionStatus() {
            try {
                this.processing = true;
                await UsersRepository.updateTransactionStatus(this.user.id);
                await this.fetchUser();
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Transfer status updated"
                });
            } catch (error) {
                this.processing = false;
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async updateBanStatus() {
            try {
                this.processing = true;
                await UsersRepository.updateBanStatus(this.user.id);
                await this.fetchUser();
                toast.fire({
                    type: "success",
                    title: "Ban status updated"
                });
                this.processing = false;
            } catch (error) {
                this.processing = false;
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        showIDCard() {
            $("#modal-identity").modal("show");
        },
        async fetchUser(page = 1) {
            var id = this.$route.params.id;
            var res = await UsersRepository.fetchUser(id, page);
            this.user = res.data;
        }
    },
    created() {
        this.fetchUser();
    }
};
</script>
